import { ErrorListener } from 'antlr4/error/ErrorListener';

// This listener raises an exception whenever parsing fails and includes the
// relevant context (current token, file location, error message). The syntax
// error is handled out-of-band so that it can be more accurately classified
// and give a more meaningful diagnostic message.
export class ThrowErrorListener extends (ErrorListener as { new(): any; }) {
  public static INSTANCE = new ThrowErrorListener();

  private constructor() { super(); }
  protected syntaxError(_recognizer, offendingSymbol, line, column, msg, _e) {
    // TODO: add new type `SyntaxErrorException` or alike to document the "schema" of what is thrown below.
    throw ({
      line: line,
      column: column,
      msg: msg,
      start: offendingSymbol.start,
      stop: offendingSymbol.stop,
      tokenIndex: offendingSymbol.tokenIndex
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/interpreter/ThrowErrorListener.ts